import { mapZipCityEstateIdToCollection } from '@portals/sip-client-data/src/general/ApiClientMapping/ApiClientMapping';
import { useFormikContext } from 'formik';
import React, { memo, useCallback, useState } from 'react';

import { FilterValuesProps } from '../../../../types';
import { mapZipCityEstateCollectionToSingleString } from '../../../../utils';
import { EstateSearchAutocomplete } from './EstateSearchAutocomplete';

const AutoCompleteWrapper = memo(EstateSearchAutocomplete);
AutoCompleteWrapper.displayName = 'AutoCompleteWrapper';

export const EstateSearchAutocompleteWrapper: React.FC = () => {
  const { values, errors, setFieldTouched, setFieldValue } = useFormikContext<FilterValuesProps>();
  const [nothingSelected, setNothingSelected] = useState(false);

  const preSelectedOptions = mapZipCityEstateIdToCollection(values['zipCityEstateId'] ?? '');

  const onSelectedOptions = useCallback((options) => {
    const value = mapZipCityEstateCollectionToSingleString(options);
    setFieldTouched('zipCityEstateId', true);
    setFieldValue('zipCityEstateId', value, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onNothingSelected = useCallback((searchIsEmpty: boolean) => {
    setNothingSelected(!searchIsEmpty);
    setFieldTouched('zipCityEstateId', true);
    setFieldValue('zipCityEstateId', '', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const textFieldProps = {
    error: nothingSelected ? Boolean(errors['zipCityEstateId']) : false,
    helperText: nothingSelected ? errors['zipCityEstateId'] : '',
    sx: {
      '& .MuiAutocomplete-inputRoot': {
        borderTopRightRadius: { sm: 0 },
        borderBottomRightRadius: { sm: 0 },
      },
    },
  };

  return (
    <AutoCompleteWrapper
      preSelectedOptions={preSelectedOptions}
      onSelectedOptions={onSelectedOptions}
      textFieldProps={textFieldProps}
      onNothingSelected={onNothingSelected}
    />
  );
};

EstateSearchAutocompleteWrapper.displayName = 'EstateSearchAutocompleteWrapper';
